import { ApiService } from '../../ApiService';
import snakecaseKeys from 'snakecase-keys';
import { ApplicationFormTemplate } from '../../../entities/applicant_tracking/ApplicationFormTemplate';
import { Source } from '../../../entities/applicant_tracking/Source';
import { JobPostSettings } from '../../../entities/v1/applicant_tracking/JobPostSettings';
import { SurveyQuestionAnswer } from '../../../entities/survey_engine/SurveyQuestionAnswer';
import { PartialBy } from '../../../utils/typeUtils';

type QuestionAnswer = PartialBy<SurveyQuestionAnswer, 'survey_id'>;

type ResumeDocument = { id?: number; content: string; filename: string };
type OtherDocument = { content: string; filename: string };

export interface SubmitApplicationDto {
  name: string;
  email: string;
  phoneNumber?: string;
  linkedinUrl?: string;
  resume: ResumeDocument;
  documents?: OtherDocument[];
  coverLetter?: OtherDocument;
  portfolioUrl: string;
  salaryExpectation: string;
  salaryCurrency: string;
  candidateConsented: boolean;
  sourceId?: number;
  slSource?: string;
  externalJobBoardCampaignId?: string;
  externalJobBoardProvider?: string;
  hasWorkingVisa: boolean;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  academicDegree?: string;
  yearsExperience?: string;
  company?: string;
  jobTitle?: string;
  customQuestionAnswers: QuestionAnswer[]; // Sparse array. Index is Question.ID
}

export class CareersService {
  public static getApplicationForm(
    organizationSubdomain: string,
    jobPostId: number,
  ): Promise<ApplicationFormTemplate> {
    return ApiService.get<ApplicationFormTemplate>(
      `/api/applicant_tracking/careers/${organizationSubdomain}/job_posts/${jobPostId}/application_form`,
    );
  }

  public static getJobPostSettings(
    organizationSubdomain: string,
    jobPostId: number,
  ): Promise<JobPostSettings> {
    return ApiService.get<JobPostSettings>(
      `/api/applicant_tracking/careers/${organizationSubdomain}/job_posts/${jobPostId}/settings`,
    );
  }

  public static getSources(organizationSubdomain: string): Promise<Source[]> {
    return ApiService.get<Source[]>(
      `/api/applicant_tracking/careers/${organizationSubdomain}/sources`,
    );
  }

  public static submitApplication(
    organizationSubdomain: string,
    jobPostId: number,
    props: SubmitApplicationDto,
  ): Promise<void> {
    return ApiService.post<void>(
      `/api/applicant_tracking/careers/${organizationSubdomain}/job_posts/${jobPostId}/submit`,
      snakecaseKeys({
        ...props,
        customQuestionAnswers: props.customQuestionAnswers?.filter((v) => v),
      }),
    );
  }
}
